export default "__VITE_ASSET__GijUtmy1__"